import { DateTime } from 'luxon';

export function dashempty<T = unknown>(value: T): T | string {
  return value || '--';
}

export function formatDate(value: string | DateTime | Date | undefined): string {
  if (!value) return '';

  let dt = value;
  if (typeof value === 'string') {
    dt = DateTime.fromISO(value, { zone: 'utc' });
  } else if (value instanceof Date) {
    dt = DateTime.fromJSDate(value);
  }
  return dt.toLocaleString(DateTime.DATE_SHORT);
}
